import { intervalToDuration, secondsToMilliseconds } from 'date-fns';
import tw from 'twin.macro';
import 'styled-components/macro';

export interface LoadingCounterProps {
  timeLeft: number;
}

const Text = tw.div`text-white`;

export const LoadingCounter = ({ timeLeft }: LoadingCounterProps) => {
  const {
    hours = 0,
    minutes = 0,
    seconds = 0,
  } = intervalToDuration({ start: 0, end: secondsToMilliseconds(timeLeft) });

  if (timeLeft <= 0) {
    return <Text>Starting soon...</Text>;
  }

  return (
    <Text>
      Estimated time: {hours > 0 && <>{hours.toString().padStart(2, '0')}:</>}
      {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
    </Text>
  );
};
